var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _path11, _g5, _g6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g7, _path28, _path29, _path30, _path31, _g8, _path32, _path33, _path34, _path35, _g9, _path36, _path37, _path38, _g10, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g11, _g12, _path56, _g13, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g14, _path73, _path74, _path75, _g15, _path76;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 35,
    viewBox: "0 0 63 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.813 27.1429C56.813 27.8066 56.2755 28.3438 55.6115 28.3438C54.9474 28.3438 54.4099 27.8066 54.4099 27.1429C54.4099 26.4791 54.9474 25.9419 55.6115 25.9419C56.2755 25.9419 56.813 26.4813 56.813 27.1429Z",
    fill: "#5FAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5822 29.5451C57.2458 29.5451 57.7837 29.0074 57.7837 28.3441C57.7837 27.6809 57.2458 27.1432 56.5822 27.1432C55.9186 27.1432 55.3806 27.6809 55.3806 28.3441C55.3806 29.0074 55.9186 29.5451 56.5822 29.5451Z",
    fill: "#5FAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4876 30.085C58.4876 30.7488 57.9501 31.286 57.286 31.286C56.622 31.286 56.0845 30.7488 56.0845 30.085C56.0845 29.4213 56.622 28.884 57.286 28.884C57.9501 28.884 58.4876 29.4213 58.4876 30.085Z",
    fill: "#5FAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6892 30.5844C59.6892 31.2481 59.1518 31.7854 58.4877 31.7854C57.8236 31.7854 57.2861 31.2481 57.2861 30.5844C57.2861 29.9206 57.8236 29.3834 58.4877 29.3834C59.1518 29.3834 59.6892 29.9206 59.6892 30.5844Z",
    fill: "#5FAEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7814 30.6554C58.445 30.6554 58.983 30.1177 58.983 29.4544C58.983 28.7911 58.445 28.2534 57.7814 28.2534C57.1178 28.2534 56.5798 28.7911 56.5798 29.4544C56.5798 30.1177 57.1178 30.6554 57.7814 30.6554Z",
    fill: "#5FAEAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38379 27.7513H4.83521V30.9591H5.38379V27.7513Z",
    fill: "#9A633E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.37712 27.7513H5.20166V30.9591H5.37712V27.7513Z",
    fill: "#919497"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10848 28.932C6.57675 28.932 7.76701 26.2336 7.76701 22.905C7.76701 19.5763 6.57675 16.8779 5.10848 16.8779C3.64022 16.8779 2.44995 19.5763 2.44995 22.905C2.44995 26.2336 3.64022 28.932 5.10848 28.932Z",
    fill: "#5FAEAE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.4347 16.9492C6.12543 18.0459 6.68956 19.8218 6.68956 21.8286C6.68956 25.1584 5.26146 27.8556 4.03103 27.8556C3.90221 27.8556 3.77118 27.8245 3.64014 27.769C4.091 28.5016 4.61515 28.9345 5.10821 28.9345C6.33865 28.9345 7.76674 26.2351 7.76674 22.9074C7.76674 19.8928 6.49633 17.3976 5.4347 16.9492Z",
    fill: "#919497"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0966 26.1199H9.11719V30.8949H10.0966V26.1199Z",
    fill: "#CD8453"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0966 26.1199H9.76123V30.8949H10.0966V26.1199Z",
    fill: "#919497"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60576 27.8311C11.8419 27.8311 13.6546 26.0192 13.6546 23.7842C13.6546 21.5492 11.8419 19.7373 9.60576 19.7373C7.36963 19.7373 5.55688 21.5492 5.55688 23.7842C5.55688 26.0192 7.36963 27.8311 9.60576 27.8311Z",
    fill: "#5FAEAE"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.889 20.441C12.3332 21.0915 12.593 21.8751 12.593 22.7209C12.593 24.9563 10.7807 26.7678 8.54414 26.7678C7.69794 26.7678 6.91171 26.508 6.26318 26.064C6.99167 27.1318 8.21766 27.8311 9.608 27.8311C11.8445 27.8311 13.6569 26.0197 13.6569 23.7842C13.6569 22.3968 12.955 21.1714 11.889 20.441Z",
    fill: "#919497"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2671 18.6387H27.4136V30.9591H55.2671V18.6387Z",
    fill: "#F8DCBB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4138 18.656H58.1279L51.2895 8.81738H27.4138V18.656Z",
    fill: "#E96666"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M55.2671 18.5902H27.4136V19.6735H55.2671V18.5902Z",
    fill: "#919497"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.5698 18.656H27.4138V8.81738H27.8891L30.5698 18.656Z",
    fill: "#919497"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9733 22.0225H38.7051V30.9598H43.9733V22.0225Z",
    fill: "#A3392D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.187 27.6692H39.509V30.3042H43.187V27.6692Z",
    fill: "#E96666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.187 22.6567H39.509V25.2918H43.187V22.6567Z",
    fill: "#E96666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.187 25.92H39.509V27.0411H43.187V25.92Z",
    fill: "#E96666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9977 22.0231H29.3391V27.0045H35.9977V22.0231Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6332 22.3362H29.7031V26.6894H35.6332V22.3362Z",
    fill: "#8CBDCF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8993 26.6889L34.7716 22.3357H33.0437L31.1714 26.6889H32.8993Z",
    fill: "#C6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0085 22.3363H31.3977L29.7031 26.2811V26.6895H30.1384L32.0085 22.3363Z",
    fill: "#C6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3414 22.0225H46.6829V27.0039H53.3414V22.0225Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9772 22.3352H47.0471V26.6884H52.9772V22.3352Z",
    fill: "#8CBDCF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.383 26.689L52.253 22.3358H50.5251L48.655 26.689H50.383Z",
    fill: "#C6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3525 22.3354H48.7417L47.0471 26.2802V26.6887H47.4824L49.3525 22.3354Z",
    fill: "#C6E6E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.067 29.7167C31.067 29.8654 30.9471 29.9853 30.7983 29.9853C30.6495 29.9853 30.5317 29.8654 30.5317 29.7167C30.5317 29.568 30.6517 29.4503 30.7983 29.4503C30.9449 29.4503 31.067 29.568 31.067 29.7167Z",
    fill: "#C6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1513 29.7587C31.2997 29.7587 31.42 29.6384 31.42 29.49C31.42 29.3417 31.2997 29.2214 31.1513 29.2214C31.0029 29.2214 30.8826 29.3417 30.8826 29.49C30.8826 29.6384 31.0029 29.7587 31.1513 29.7587Z",
    fill: "#C6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.46 29.6365C31.46 29.7853 31.3401 29.9051 31.1935 29.9051C31.0447 29.9051 30.927 29.7853 30.927 29.6365C30.927 29.4878 31.0469 29.3701 31.1935 29.3701C31.3401 29.3679 31.46 29.4878 31.46 29.6365Z",
    fill: "#C6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7887 29.5966C31.7887 29.7453 31.6688 29.863 31.5222 29.863C31.3756 29.863 31.2534 29.7431 31.2534 29.5966C31.2534 29.4479 31.3734 29.328 31.5222 29.328C31.671 29.328 31.7887 29.4479 31.7887 29.5966Z",
    fill: "#C6E6E6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.6822 29.3859C31.7177 29.4303 31.7377 29.4858 31.7377 29.5479C31.7377 29.6966 31.6178 29.8143 31.4712 29.8143C31.409 29.8143 31.3535 29.7921 31.3091 29.7588C31.3579 29.8232 31.4335 29.8631 31.5201 29.8631C31.6689 29.8631 31.7866 29.7433 31.7866 29.5968C31.7888 29.5102 31.7466 29.4347 31.6822 29.3859Z",
    fill: "#919497"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9111 30.0249C32.0595 30.0249 32.1798 29.9046 32.1798 29.7563C32.1798 29.6079 32.0595 29.4877 31.9111 29.4877C31.7627 29.4877 31.6423 29.6079 31.6423 29.7563C31.6423 29.9046 31.7627 30.0249 31.9111 30.0249Z",
    fill: "#C6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5794 29.6365C32.5794 29.7852 32.4595 29.9051 32.3107 29.9051C32.1619 29.9051 32.0442 29.7852 32.0442 29.6365C32.0442 29.4878 32.1641 29.3701 32.3107 29.3701C32.4573 29.3701 32.5794 29.4878 32.5794 29.6365Z",
    fill: "#C6E6E6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.806 29.7167C32.806 29.8654 32.6861 29.9853 32.5395 29.9853C32.3929 29.9853 32.2708 29.8654 32.2708 29.7167C32.2708 29.568 32.3907 29.4503 32.5395 29.4503C32.6883 29.4503 32.806 29.568 32.806 29.7167Z",
    fill: "#C6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2416 29.7167C33.2416 29.8654 33.1216 29.9853 32.975 29.9853C32.8285 29.9853 32.7063 29.8654 32.7063 29.7167C32.7063 29.568 32.8262 29.4503 32.975 29.4503C33.1238 29.4503 33.2416 29.568 33.2416 29.7167Z",
    fill: "#C6E6E6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.6949 29.4979C32.726 29.5423 32.746 29.5956 32.746 29.6533C32.746 29.8021 32.626 29.9219 32.4794 29.9219C32.4217 29.9219 32.3684 29.9019 32.324 29.8709C32.3728 29.9375 32.4506 29.9819 32.5416 29.9819C32.6904 29.9819 32.8081 29.862 32.8081 29.7132C32.8059 29.6267 32.7615 29.5468 32.6949 29.4979Z",
    fill: "#919497"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2725 29.5433C33.2725 29.692 33.1526 29.8119 33.006 29.8119C32.8572 29.8119 32.7395 29.692 32.7395 29.5433C32.7395 29.3945 32.8594 29.2747 33.006 29.2747C33.1526 29.2747 33.2725 29.3945 33.2725 29.5433Z",
    fill: "#C6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6478 29.7167C33.6478 29.8654 33.5279 29.9853 33.3813 29.9853C33.2347 29.9853 33.1125 29.8654 33.1125 29.7167C33.1125 29.568 33.2325 29.4503 33.3813 29.4503C33.5301 29.4503 33.6478 29.568 33.6478 29.7167Z",
    fill: "#C6E6E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9964 29.7167C33.9964 29.8654 33.8765 29.9853 33.7299 29.9853C33.5833 29.9853 33.4612 29.8654 33.4612 29.7167C33.4612 29.568 33.5811 29.4503 33.7299 29.4503C33.8787 29.4503 33.9964 29.568 33.9964 29.7167Z",
    fill: "#C6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7299 29.8652C33.8783 29.8652 33.9987 29.745 33.9987 29.5966C33.9987 29.4483 33.8783 29.328 33.7299 29.328C33.5815 29.328 33.4612 29.4483 33.4612 29.5966C33.4612 29.745 33.5815 29.8652 33.7299 29.8652Z",
    fill: "#C6E6E6"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.8922 29.3859C33.9277 29.4303 33.9477 29.4858 33.9477 29.5479C33.9477 29.6966 33.8278 29.8165 33.6812 29.8165C33.619 29.8165 33.5635 29.7943 33.519 29.761C33.5679 29.8254 33.6434 29.8654 33.73 29.8654C33.8788 29.8654 33.9966 29.7455 33.9966 29.599C33.9966 29.5102 33.9544 29.4347 33.8922 29.3859Z",
    fill: "#919497"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0366 30.0519C34.185 30.0519 34.3053 29.9316 34.3053 29.7832C34.3053 29.6349 34.185 29.5146 34.0366 29.5146C33.8881 29.5146 33.7678 29.6349 33.7678 29.7832C33.7678 29.9316 33.8881 30.0519 34.0366 30.0519Z",
    fill: "#C6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6517 29.7167C34.6517 29.8654 34.5318 29.9853 34.3852 29.9853C34.2386 29.9853 34.1165 29.8654 34.1165 29.7167C34.1165 29.568 34.2364 29.4503 34.3852 29.4503C34.534 29.4503 34.6517 29.568 34.6517 29.7167Z",
    fill: "#C6E6E6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2936 29.6898C35.2936 29.8385 35.1736 29.9584 35.0248 29.9584C34.876 29.9584 34.7583 29.8385 34.7583 29.6898C34.7583 29.541 34.8782 29.4234 35.0248 29.4234C35.1736 29.4212 35.2936 29.541 35.2936 29.6898Z",
    fill: "#C6E6E6"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.1958 29.4824C35.2269 29.5268 35.2446 29.5779 35.2446 29.6356C35.2446 29.7843 35.1247 29.9042 34.9781 29.9042C34.9137 29.9042 34.856 29.8798 34.8093 29.842C34.8582 29.9109 34.9381 29.9575 35.0292 29.9575C35.178 29.9575 35.2979 29.8376 35.2979 29.6889C35.2935 29.6045 35.2557 29.5313 35.1958 29.4824Z",
    fill: "#919497"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3051 29.8652C34.4535 29.8652 34.5739 29.745 34.5739 29.5966C34.5739 29.4483 34.4535 29.328 34.3051 29.328C34.1567 29.328 34.0364 29.4483 34.0364 29.5966C34.0364 29.745 34.1567 29.8652 34.3051 29.8652Z",
    fill: "#C6E6E6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0269 29.7562C35.0269 29.905 34.907 30.0249 34.7604 30.0249C34.6138 30.0249 34.4939 29.905 34.4939 29.7562C34.4939 29.6075 34.6138 29.4899 34.7604 29.4899C34.907 29.4899 35.0269 29.6075 35.0269 29.7562Z",
    fill: "#C6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3208 29.501C34.3208 29.5521 34.2786 29.5943 34.2276 29.5943C34.1765 29.5943 34.1343 29.5521 34.1343 29.501C34.1343 29.45 34.1765 29.4078 34.2276 29.4078C34.2786 29.4056 34.3208 29.4478 34.3208 29.501Z",
    fill: "#FCEE21"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8028 29.6897C34.8028 29.7407 34.7606 29.7829 34.7095 29.7829C34.6584 29.7829 34.6162 29.7407 34.6162 29.6897C34.6162 29.6386 34.6584 29.5964 34.7095 29.5964C34.7606 29.5964 34.8028 29.6386 34.8028 29.6897Z",
    fill: "#93278F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1853 29.6986C34.1853 29.7497 34.1431 29.7918 34.0921 29.7918C34.041 29.7918 33.9988 29.7497 33.9988 29.6986C33.9988 29.6475 34.041 29.6053 34.0921 29.6053C34.1431 29.6053 34.1853 29.6475 34.1853 29.6986Z",
    fill: "#FCEE21"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7789 29.4481C33.7789 29.4992 33.7367 29.5413 33.6856 29.5413C33.6345 29.5413 33.5923 29.4992 33.5923 29.4481C33.5923 29.397 33.6345 29.3549 33.6856 29.3549C33.7367 29.3549 33.7789 29.397 33.7789 29.4481Z",
    fill: "#93278F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3348 29.4634C33.3348 29.5144 33.2926 29.5566 33.2415 29.5566C33.1904 29.5566 33.1482 29.5144 33.1482 29.4634C33.1482 29.4123 33.1904 29.3701 33.2415 29.3701C33.2926 29.3701 33.3348 29.4123 33.3348 29.4634Z",
    fill: "#FCEE21"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0525 29.5968C33.0525 29.6478 33.0103 29.69 32.9592 29.69C32.9082 29.69 32.866 29.6478 32.866 29.5968C32.866 29.5457 32.9082 29.5035 32.9592 29.5035C33.0125 29.5035 33.0525 29.5435 33.0525 29.5968Z",
    fill: "#93278F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8526 29.4899C32.8526 29.541 32.8104 29.5832 32.7593 29.5832C32.7082 29.5832 32.666 29.541 32.666 29.4899C32.666 29.4389 32.7082 29.3967 32.7593 29.3967C32.8104 29.3945 32.8526 29.4367 32.8526 29.4899Z",
    fill: "#93278F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.459 29.7164C33.459 29.7675 33.4168 29.8096 33.3657 29.8096C33.3147 29.8096 33.2725 29.7675 33.2725 29.7164C33.2725 29.6653 33.3147 29.6232 33.3657 29.6232C33.4168 29.6232 33.459 29.6653 33.459 29.7164Z",
    fill: "#93278F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32.364 29.6632C32.364 29.7142 32.3219 29.7564 32.2708 29.7564C32.2197 29.7564 32.1775 29.7142 32.1775 29.6632C32.1775 29.6121 32.2197 29.5699 32.2708 29.5699C32.3219 29.5699 32.364 29.6121 32.364 29.6632Z",
    fill: "#93278F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4197 29.4059C32.4197 29.4569 32.3775 29.4991 32.3264 29.4991C32.2754 29.4991 32.2332 29.4569 32.2332 29.4059C32.2332 29.3548 32.2754 29.3126 32.3264 29.3126C32.3775 29.3126 32.4197 29.3548 32.4197 29.4059Z",
    fill: "#FCEE21"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6912 29.4391C31.6912 29.4901 31.649 29.5323 31.5979 29.5323C31.5468 29.5323 31.5046 29.4901 31.5046 29.4391C31.5046 29.388 31.5468 29.3458 31.5979 29.3458C31.649 29.3458 31.6912 29.388 31.6912 29.4391Z",
    fill: "#FCEE21"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2068 29.5013C31.2068 29.5524 31.1646 29.5945 31.1135 29.5945C31.0625 29.5945 31.0203 29.5524 31.0203 29.5013C31.0203 29.4503 31.0625 29.4081 31.1135 29.4081C31.1646 29.4081 31.2068 29.448 31.2068 29.5013Z",
    fill: "#FCEE21"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 29.6364C31.6133 29.6875 31.5711 29.7297 31.52 29.7297C31.469 29.7297 31.4268 29.6875 31.4268 29.6364C31.4268 29.5854 31.469 29.5432 31.52 29.5432C31.5711 29.5432 31.6133 29.5832 31.6133 29.6364Z",
    fill: "#FCEE21"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8738 29.6564C30.8738 29.7074 30.8316 29.7496 30.7805 29.7496C30.7295 29.7496 30.6873 29.7074 30.6873 29.6564C30.6873 29.6053 30.7295 29.5631 30.7805 29.5631C30.8316 29.5631 30.8738 29.6053 30.8738 29.6564Z",
    fill: "#93278F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3092 30.9311H30.4363L30.1831 29.8212H35.5624L35.3092 30.9311Z",
    fill: "#A3392D"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.3423 29.821L35.0891 30.931H35.309L35.5622 29.821H35.3423Z",
    fill: "#919497"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.7806 19.6733H27.4136V30.9305H30.7806V19.6733Z",
    fill: "#919497"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7448 3.39844L12.0779 8.81722V30.9586H27.4139V8.81722L19.7448 3.39844Z",
    fill: "#FFF1D5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.0779 9.16364V11.7742L20.0246 5.73611L27.4139 11.3502V9.16364L19.7448 3.74707L12.0779 9.16364Z",
    fill: "#919497"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99341 10.9285L9.38153 12.7532L19.7447 4.87699L30.1101 12.7532L31.4982 10.9285L19.7447 2L7.99341 10.9285Z",
    fill: "#BA5151"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3866 22.0211H14.7275V27.0026H24.3866V22.0211Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0112 22.3351H15.1028V26.6883H24.0112V22.3351Z",
    fill: "#8CBDCF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.299 26.6881L20.1691 22.3348H18.4433L16.571 26.6881H18.299Z",
    fill: "#C3EFEF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4082 22.3348H16.7974L15.1028 26.2796V26.6881H15.5381L17.4082 22.3348Z",
    fill: "#C3EFEF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6335 22.3351H19.478V26.6883H19.6335V22.3351Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3866 12.0759H14.7275V17.0574H24.3866V12.0759Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0112 12.3888H15.1028V16.742H24.0112V12.3888Z",
    fill: "#8CBDCF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.299 16.7417L20.1691 12.3884H18.4433L16.571 16.7417H18.299Z",
    fill: "#C3EFEF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4082 12.3888H16.7974L15.1028 16.3336V16.742H15.5381L17.4082 12.3888Z",
    fill: "#C3EFEF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6335 12.3888H19.478V16.742H19.6335V12.3888Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4149 30.5543C53.4149 31.0804 52.9885 31.5088 52.4599 31.5088C51.9335 31.5088 51.5049 31.0826 51.5049 30.5543C51.5049 30.0282 51.9313 29.5997 52.4599 29.5997C52.9885 29.5997 53.4149 30.0282 53.4149 30.5543Z",
    fill: "#5FAEAE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.37 29.9817C54.37 30.5078 53.9436 30.9362 53.415 30.9362C52.8886 30.9362 52.46 30.51 52.46 29.9817C52.46 29.4555 52.8864 29.0271 53.415 29.0271C53.9414 29.0293 54.37 29.4555 54.37 29.9817Z",
    fill: "#5FAEAE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9674 30.5543C54.9674 31.0804 54.541 31.5088 54.0124 31.5088C53.486 31.5088 53.0574 31.0826 53.0574 30.5543C53.0574 30.0282 53.4838 29.5997 54.0124 29.5997C54.5388 29.5997 54.9674 30.0282 54.9674 30.5543Z",
    fill: "#5FAEAE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5822 30.5543C56.5822 31.0804 56.1557 31.5088 55.6271 31.5088C55.1008 31.5088 54.6721 31.0826 54.6721 30.5543C54.6721 30.0282 55.0986 29.5997 55.6271 29.5997C56.1535 29.5997 56.5822 30.0282 56.5822 30.5543Z",
    fill: "#5FAEAE"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8581 29.296C55.8581 29.8221 55.4316 30.2506 54.903 30.2506C54.3767 30.2506 53.948 29.8243 53.948 29.296C53.948 28.7699 54.3744 28.3414 54.903 28.3414C55.4316 28.3437 55.8581 28.7699 55.8581 29.296Z",
    fill: "#5FAEAE"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.4807 29.5365C54.6184 29.7163 54.7028 29.9427 54.7028 30.1869C54.7028 30.7796 54.2209 31.2614 53.6279 31.2614C53.4102 31.2614 53.2081 31.197 53.0393 31.0838C53.2348 31.3413 53.5435 31.5078 53.8922 31.5078C54.4852 31.5078 54.9671 31.026 54.9671 30.4333C54.9671 30.0582 54.7739 29.7274 54.4807 29.5365Z",
    fill: "#919497"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0394 29.6308C57.0394 30.1569 56.613 30.5854 56.0844 30.5854C55.558 30.5854 55.1294 30.1592 55.1294 29.6308C55.1294 29.1047 55.5558 28.6763 56.0844 28.6763C56.613 28.6763 57.0394 29.1025 57.0394 29.6308Z",
    fill: "#5FAEAE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5348 30.936C57.5348 31.4621 57.1084 31.8906 56.5798 31.8906C56.0534 31.8906 55.6248 31.4643 55.6248 30.936C55.6248 30.4099 56.0512 29.9814 56.5798 29.9814C57.1084 29.9814 57.5348 30.4099 57.5348 30.936Z",
    fill: "#5FAEAE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5822 28.583C56.5822 29.1091 56.1557 29.5375 55.6271 29.5375C55.1008 29.5375 54.6721 29.1113 54.6721 28.583C54.6721 28.0569 55.0986 27.6284 55.6271 27.6284C56.1535 27.6306 56.5822 28.0569 56.5822 28.583Z",
    fill: "#5FAEAE"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M56.9395 30.0527C57.0039 29.9262 57.0394 29.7819 57.0394 29.6287C57.0394 29.2735 56.844 28.9627 56.5553 28.7984C56.5708 28.7296 56.5819 28.6564 56.5819 28.5809C56.5819 28.0548 56.1555 27.6263 55.6269 27.6263C55.6224 27.6263 55.618 27.6263 55.6113 27.6263C55.8956 27.7906 56.0844 28.097 56.0844 28.4499C56.0844 28.5254 56.0755 28.5964 56.0577 28.6675C56.3465 28.8318 56.5419 29.1403 56.5419 29.4977C56.5419 29.6509 56.5064 29.793 56.442 29.9217C56.7907 30.0638 57.0372 30.4057 57.0372 30.8052C57.0372 31.3269 56.6197 31.7487 56.0999 31.7576C56.2399 31.8397 56.4042 31.8886 56.5775 31.8886C57.1038 31.8886 57.5325 31.4623 57.5325 30.934C57.5347 30.5366 57.2882 30.1948 56.9395 30.0527Z",
    fill: "#919497"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5632 30.9301H0V32H62.5632V30.9301Z",
    fill: "#5FAEAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c48c21d57d469a5451f2eb5e4847eaa4.svg";
export { ForwardRef as ReactComponent };